import React from "react";
import "./WhyChooseHomeshiksha.css";

// Importing SVGs from the local folder
import DedicatedSupportIcon from "./icons/dedicated-support.svg";
import EarnBigIcon from "./icons/earn-big.svg";
import FlexibleSecureIcon from "./icons/flexible-secure.svg";
import GuaranteedRefundIcon from "./icons/guaranteed-tution-refund.svg";
import NoBondContractsIcon from "./icons/no-bond-contracts.svg";
import TeachPassionIcon from "./icons/teach-passion.svg";
import TopRatedAndTrustedIcon from "./icons/top-rated-trusted.svg";
import VipClientsIcon from "./icons/vip-clients.svg";

const features = [
  {
    title: "Earn Big, Teach Smart",
    description: "Join 15,000+ tutors earning with guaranteed tuition opportunities.",
    icon: EarnBigIcon,
  },
  {
    title: "Flexible & Secure",
    description: "Choose part-time or full-time assignments, set your schedule, and teach at your preferred location.",
    icon: FlexibleSecureIcon,
  },
  {
    title: "VIP & Long-Term Clients",
    description: "Work with high-profile clients and secure consistent, ongoing assignments.",
    icon: VipClientsIcon,
  },
  {
    title: "Guaranteed Tuitions or Refund",
    description: "Get assured tuition opportunities or receive a refund.",
    icon: GuaranteedRefundIcon,
  },
  {
    title: "Get Dedicated Support",
    description:
      "Dedicated customer service for all your queries and tuition assignments with direct phone contact numbers.",
    icon: DedicatedSupportIcon,
  },
  {
    title: "Teach Your Passion",
    description: "Focus on academic or cocurricular subjects you love.",
    icon: TeachPassionIcon,
  },
  {
    title: "No bonds, no contracts!",
    description: "Work as a freelancer and manage tutoring on your own terms.",
    icon: NoBondContractsIcon,
  },
  {
    title: "Top-Rated & Trusted",
    description: "India’s best home tutor provider with a 4.7+ rating on Google, Justdial, and MouthShut.",
    icon: TopRatedAndTrustedIcon,
  },
];

const WhyChooseHomeShiksha = () => {
  return (
    <section className="why-choose-section">
      <h2 className="section-title">
        Why To Choose <span className="highlight">HomeShiksha</span>
      </h2>
      <div className="features-container">
        {features.map((feature, index) => (
          <div className="feature-box" key={index}>
            <img src={feature.icon} alt={feature.title} className="feature-icon" />
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseHomeShiksha;
